<ion-content class="ion-padding">
    <div class="max-page-width">
        <ion-item lines="none" mode="ios" class="title-with-back-button">
            <ion-button fill="clear" mode="ios" color="primary" (click)="goBack()">
                <ion-icon class="bp-arrow-left"></ion-icon>
            </ion-button>
            <ion-label class="ion-text-center ion-text-wrap">
                {{ getText(isConsentValid ? processConfig?.consentGoalsGlobalizationConfig : processConfig?.globalizationConfig, 'title') | uppercase }}
            </ion-label>
        </ion-item>

        <app-step-description
                [description]="getText( isConsentValid 
                ? processConfig?.consentGoalsGlobalizationConfig 
                : processConfig?.globalizationConfig,
                 'instructions' )"
        ></app-step-description>

        <ng-container *ngIf="hasRejectGoals()">
            <ion-item lines="none" mode="ios" class="para-content">
                <ion-icon slot="start" class="bp-not-accepted danger"></ion-icon>
                <ion-label class="ion-text-wrap" color="danger">
                    <p>
                        <small>{{ 'goalsInput.hasGoalsRejected' | translate }}</small>
                    </p>
                </ion-label>
                <ion-button
                        slot="end"
                        mode="ios"
                        color="danger"
                        (click)="viewRejectionFeedbacks(goals)">
                    {{ 'goalsInput.seeFeedback' | translate }}
                </ion-button>
            </ion-item>
        </ng-container>

        <ion-card mode="ios" class="card-table-data">
            <ion-grid>
                <ion-row>
                    <ion-col size="8">
                        <ion-list class="inputs-progress">
                            <ion-list-header>
                                <ion-label>
                                    {{ 'goalsInput.totalWeight' | translate }}: {{ getTotalWeight() }}% / 100%
                                </ion-label>
                            </ion-list-header>
                            <ion-progress-bar
                                    [value]="getTotalWeight() / 100"
                            ></ion-progress-bar>
                        </ion-list>
                    </ion-col>
                    <ion-col size="4">
                        <ion-card-header *ngIf="canAddGoal()" goRight>
                            <ion-button
                                    *ngIf="!isConsentValid"
                                    mode="ios"
                                    color="secondary"
                                    id="newGoalButton"
                                    (click)="openManageGoalsInputModal()">
                                {{ 'goalsInput.newGoalBtn' | translate }}
                            </ion-button>
                        </ion-card-header>
                    </ion-col>
                </ion-row>
            </ion-grid>

            <ion-card-content class="ion-no-padding">
                <ion-grid class="table-view">
                    <ion-row hidden-mobile class="header ion-no-padding">
                        <ion-col *ngIf="processConfig?.title 
                        || processConfig?.description" [sizeMd]="getColumnSize(processConfig?.questions.length)">
                            {{ 'generic.goal' | translate }}
                        </ion-col>
                        <ion-col *ngIf="processConfig?.weight" [sizeMd]="getColumnSize(processConfig?.questions.length)">
                            {{ 'generic.weight' | translate }}
                        </ion-col>
                        <ion-col *ngIf="processConfig?.deadline" [sizeMd]="getColumnSize(processConfig?.questions.length)">
                            {{ 'generic.deadline' | translate }}
                        </ion-col>
                        <ion-col *ngIf="processConfig?.initialDeadline" [sizeMd]="getColumnSize(processConfig?.questions.length)">
                            {{ 'generic.initialDeadline' | translate }}
                        </ion-col>
                        <ng-container *ngIf="processConfig?.questions">
                            <ion-col
                                    [sizeMd]="getColumnSize(processConfig.questions.length)"
                                    *ngFor="let question of processConfig.questions">
                                {{ getText(question.globalizationConfig, 'title') }}
                            </ion-col>
                        </ng-container>
                        <ion-col *ngIf="!isConsentValid"
                                 [sizeMd]="getColumnSize(processConfig?.questions.length)">
                            {{ 'generic.validation' | translate }}
                        </ion-col>
                    </ion-row>

                    <ion-row *ngFor="let goal of displayedGoals" class="ion-no-padding">
                        <!-- Previous Changes -->
                        <ng-container *ngIf="goal.lastVersion">
                            <ion-col
                                    *ngIf="processConfig?.title || processConfig?.description"
                                    [sizeMd]="getColumnSize(processConfig?.questions.length)"
                                    class="ion-align-self-center"
                                    faded>
                                <div class="content">
                                    <p class="label-heading" hidden-desktop>
                                        {{ 'generic.goal' | translate }}
                                    </p>
                                    <h2>{{ goal.lastVersion.title }}</h2>
                                    <p class="underline-text">
                                        {{ goal.lastVersion.description }}
                                    </p>
                                </div>
                            </ion-col>
                            <ion-col
                                    *ngIf="processConfig?.weight"
                                    class="ion-align-self-center"
                                    [sizeMd]="getColumnSize(processConfig?.questions.length)"
                                    faded>
                                <p class="label-heading" hidden-desktop>
                                    {{ 'generic.weight' | translate }}
                                </p>
                                {{ goal.lastVersion.weight }}%
                            </ion-col>
                            <ion-col
                                    *ngIf="processConfig?.deadline"
                                    class="ion-align-self-center"
                                    [sizeMd]="getColumnSize(processConfig?.questions.length)"
                                    faded>
                                <p class="label-heading" hidden-desktop>
                                    {{ 'generic.deadline' | translate }}
                                </p>
                                {{ goal.lastVersion.deadline | date : 'dd/MM/yyyy' }}
                            </ion-col>
                            <ion-col
                                    *ngIf="processConfig?.initialDeadline"
                                    class="ion-align-self-center"
                                    [sizeMd]="getColumnSize(processConfig?.questions.length)"
                                    faded>
                                <p class="label-heading" hidden-desktop>
                                    {{ 'generic.initialDeadline' | translate }}
                                </p>
                                {{ goal.lastVersion.initialDeadline | date : 'dd/MM/yyyy' }}
                            </ion-col>
                            <ng-container *ngIf="processConfig?.questions">
                                <ion-col
                                        class="ion-align-self-center"
                                        [sizeMd]="getColumnSize(processConfig.questions.length)"
                                        *ngFor="let question of processConfig.questions; let index = index"
                                        faded>
                                    <p class="label-heading" hidden-desktop>
                                        {{ getText(question.globalizationConfig, 'title') }}
                                    </p>
                                    <ng-container *ngIf="question.typeConfig.type === QuestionType.Date 
                                                    || question.typeConfig.type === QuestionType.Deadline">
                                        {{
                                            goal.lastVersion['field' + (index + 1)] | translate |
                                                    date:'dd/MM/yyyy'
                                        }}
                                    </ng-container>
                                    <ng-container *ngIf="question.typeConfig.type === QuestionType.Weight">
                                        {{ goal.lastVersion['field' + (index + 1)] | translate }} %
                                    </ng-container>
                                    <ng-container *ngIf="question.typeConfig.type !== QuestionType.Date 
                                                        && question.typeConfig.type !== QuestionType.Weight">
                                        {{
                                            question.typeConfig?.possibleValuesGlobalized &&
                                            question.typeConfig?.possibleValuesGlobalized[selectedLanguage]?.length > 0 &&
                                            question.typeConfig?.possibleValues &&
                                            question.typeConfig?.possibleValues?.length > 0
                                                    ?
                                                    (
                                                            question.typeConfig?.possibleValuesGlobalized[selectedLanguage].indexOf(goal.lastVersion['field' + (index + 1)]
                                                                    ?
                                                                    question.typeConfig?.possibleValuesGlobalized[selectedLanguage][question.typeConfig?.possibleValuesGlobalized[selectedLanguage].indexOf(goal.lastVersion['field' + (index + 1)])]
                                                                    :
                                                                    question.typeConfig?.possibleValuesGlobalized[selectedLanguage][question.typeConfig?.possibleValues.indexOf(goal.lastVersion['field' + (index + 1)])])
                                                    )
                                                    :
                                                    (goal.lastVersion['field' + (index + 1)] | translate)
                                        }}
                                    </ng-container>
                                </ion-col>
                            </ng-container>
                            <ion-col
                                    class="ion-align-self-center"
                                    hidden-mobile
                                    [sizeMd]="getColumnSize(processConfig.questions.length)"
                                    faded
                            >
                                <p><b>{{ 'generic.beforeEditing' | translate }}</b></p>
                            </ion-col>
                        </ng-container>
                        <!-- Current Changes -->
                        <ion-col
                                *ngIf="processConfig?.title || processConfig?.description"
                                [sizeMd]="getColumnSize(processConfig?.questions.length)"
                                size-xs="12"
                                class="ion-align-self-center">
                            <div class="content">
                                <p class="label-heading" hidden-desktop>
                                    {{ 'generic.goal' | translate }}
                                </p>
                                <h2 [id]="goal.title">{{ goal.title }}</h2>
                                <p class="underline-text">{{ goal.description }}</p>
                            </div>
                        </ion-col>
                        <ion-col *ngIf="processConfig?.weight"
                                 class="ion-align-self-center"
                                 [sizeMd]="getColumnSize(processConfig?.questions.length)">
                            <p class="label-heading" hidden-desktop>
                                {{ 'generic.weight' | translate }}
                            </p>
                            {{ goal.weight }}%
                        </ion-col>
                        <ion-col
                                *ngIf="processConfig?.deadline"
                                class="ion-align-self-center"
                                [sizeMd]="getColumnSize(processConfig?.questions.length)">
                            <p class="label-heading" hidden-desktop>
                                {{ 'generic.deadline' | translate }}
                            </p>
                            {{ goal.deadline | date : 'dd/MM/yyyy' }}
                        </ion-col>
                        <ion-col
                                *ngIf="processConfig?.initialDeadline"
                                class="ion-align-self-center"
                                [sizeMd]="getColumnSize(processConfig?.questions.length)">
                            <p class="label-heading" hidden-desktop>
                                {{ 'generic.initialDeadline' | translate }}
                            </p>
                            {{ goal.initialDeadline | date : 'dd/MM/yyyy' }}
                        </ion-col>
                        <ng-container>
                            <ion-col
                                    class="ion-align-self-center"
                                    [sizeMd]="getColumnSize(processConfig?.questions.length)"
                                    *ngFor="let question of processConfig.questions; let index = index">
                                <p class="label-heading" hidden-desktop>
                                    {{ getText(question.globalizationConfig, 'title') }}
                                </p>
                                <ng-container *ngIf="question.typeConfig.type === QuestionType.Date 
                                                    || question.typeConfig.type === QuestionType.Deadline
                                                    || question.typeConfig.type === QuestionType.InitialDeadline">
                                    {{
                                        goal['field' + (index + 1)] | translate | date:'dd/MM/yyyy'
                                    }}
                                </ng-container>
                                <ng-container *ngIf="question.typeConfig.type === QuestionType.Weight">
                                    {{ goal['field' + (index + 1)] | translate }} %
                                </ng-container>
                                <ng-container *ngIf="question.typeConfig.type !== QuestionType.Date
                                                     && question.typeConfig.type !== QuestionType.Weight 
                                                     && question.typeConfig.type !== QuestionType.Deadline
                                                    && question.typeConfig.type !== QuestionType.InitialDeadline">
                                    {{
                                        question.typeConfig?.possibleValuesGlobalized
                                        && question.typeConfig?.possibleValuesGlobalized[selectedLanguage]?.length > 0
                                        && question.typeConfig?.possibleValues
                                        && question.typeConfig?.possibleValues?.length > 0
                                                ?
                                                question.typeConfig?.possibleValuesGlobalized[selectedLanguage][question.typeConfig?.possibleValues.indexOf(goal['field' + (index + 1)])]
                                                :
                                                (goal['field' + (index + 1)] | translate)
                                    }}
                                </ng-container>
                            </ion-col>
                        </ng-container>
                        <ion-col *ngIf="!isConsentValid"
                                 [sizeMd]="getColumnSize(processConfig?.questions.length)"
                                 size-xs="12">
                            <p class="label-heading" hidden-desktop>
                                {{ 'generic.validation' | translate }}
                            </p>
                            <div class="buttons" style="justify-content: center">
                                <ng-container
                                        *ngIf="(
                                                goal.status == SubordinateGoalStatus.Pending 
                                                || goal.status == SubordinateGoalStatus.WaitingChanges
                                           )">
                                    <ion-button
                                            class="edit"
                                            color="primary"
                                            fill="clear"
                                            mode="ios"
                                            (click)="openManageGoalsInputModal(goal)">
                                        <ion-icon class="bp-edit"></ion-icon>
                                    </ion-button>
                                    <ion-button
                                            class="delete"
                                            color="danger"
                                            fill="clear"
                                            mode="ios"
                                            (click)="confirmDeleteGoal(goal)">
                                        <ion-icon class="bp-delete"></ion-icon>
                                    </ion-button>
                                </ng-container>
                            </div>

                            <div class="buttons" style="justify-content: center">
                                <ng-container [ngSwitch]="goal.status">
                                    <ion-button
                                            color="warning"
                                            fill="clear"
                                            mode="ios"
                                            *ngSwitchCase="SubordinateGoalStatus.WaitingValidation">
                                        {{ 'goalsInput.waitingValidation' | translate }}
                                        <ion-icon class="bp-edit" slot="end"></ion-icon>
                                    </ion-button>
                                    <ion-button
                                            color="success"
                                            fill="clear"
                                            mode="ios"
                                            *ngSwitchCase="SubordinateGoalStatus.Validated">
                                        {{ 'generic.validated' | translate }}
                                        <ion-icon class="bp-check" slot="end"></ion-icon>
                                    </ion-button>
                                    <ion-button
                                            color="danger"
                                            fill="clear"
                                            mode="ios"
                                            *ngSwitchCase="SubordinateGoalStatus.WaitingChanges">
                                        {{ 'generic.rejected' | translate }}
                                        <ion-icon class="bp-not-accepted" slot="end"></ion-icon>
                                    </ion-button>
                                </ng-container>
                            </div>
                        </ion-col>
                    </ion-row>
                </ion-grid>
            </ion-card-content>
        </ion-card>

        <div class="bottom-buttons ion-text-right">
            <ion-button
                    mode="ios"
                    color="secondary"
                    class="send"
                    id="sendGoalsButton"
                    *ngIf="canEditGoals(goals)"
                    (click)="isConsentValid ? submitConsentGoals(goals) : submitGoals(goals)">
                {{ (isConsentValid ? 'goals.consentGoalsBtn' : 'goalsInput.sendGoalsBtn') | translate }}
            </ion-button>
        </div>
    </div>
</ion-content>
